import { h as __h } from "preact";
import html from "~/util/html.js";
import util from "~/style/util.js";

/**
 * @typedef {object} Props
 * @property {string} name
 * @property {number} [size]
 * @property {string} [label]
 * @property {number} [stroke]
 */

/** @param {Props} props */
export default function Icon(props) {
  const {
    name,
    size = 18,
    stroke,
    label
  } = props;
  return [__h("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    "class": util.shrink0,
    "stroke-width": stroke,
    "aria-hidden": true
  }, __h("use", {
    href: "/icons.svg#" + name
  })), label ? __h("span", {
    "class": util.visuallyHidden
  }, label) : null];
}